module.exports = __webpack_public_path__ + "img/democratic-republic-of-congo.01aaecd6.svg";